import type { TargetedEvent, VNode } from 'preact';

import type { ExternalPageSize } from 'Models/pagination';

interface Props {
  pageSize: number | string;
  pageSizes: (number | string)[];
  setPageSize: (size: ExternalPageSize) => void;
  className?: string;
}

export default function PageSizeSelect({
  pageSize,
  pageSizes,
  setPageSize,
  className,
}: Props): VNode<object> {
  const onChange = (e: TargetedEvent<HTMLSelectElement, Event>) => {
    const { value } = e.currentTarget;
    setPageSize(value === 'all' ? 'all' : Number(value));
  };

  const props = { onChange, className, value: pageSize };

  return (
    <select {...props}>
      {pageSizes.map((configValue) => (
        <option value={isNaN(Number(configValue)) ? 'all' : configValue} key={configValue}>
          {configValue}
        </option>
      ))}
    </select>
  );
}
